import {
  Component,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'claims-athome-myaccount-manage-my-repair-detail-group-section',
  templateUrl: './detail-group-section.component.html',
  styleUrls: ['./detail-group-section.component.scss'],
})
export class ManageMyRepairDetailGroupSectionComponent implements OnChanges {
  @Input() iconName: string;
  private readonly mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  isMobile = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = this.detectMobileDevice();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.iconName) {
      this.isMobile = this.detectMobileDevice();
    }
  }

  private detectMobileDevice(): boolean {
    return (
      this.mobileRegex.test(navigator.userAgent) || navigator.maxTouchPoints > 0
    );
  }
}
